var css = {"content":"Collapsible-module_content__0aZPG","open":"Collapsible-module_open__viMPj","close":"Collapsible-module_close__y3-4g"};

export { css as default };
